<div class="isla-contenedor magico-100">
  <button
    irxBotonIcono="imagen"
    tamano="mini"
    tooltip="Cerrar"
    (click)="close()"
    class="isla-close"
  >
    <mat-icon>close</mat-icon>
  </button>

  @if (reporte?.activo) {
    <!-- Loading -->
    @if (this.loading.getLoading()) {
      <mat-progress-bar
        mode="indeterminate"
        color="primary"
        class="isla-loading"
      ></mat-progress-bar>
    }

    <!-- Tarjeta principal -->
    <mat-card class="isla-main-card">
      <!-- Encabezado -->
      <mat-card-header class="isla-header">
        <mat-card-title>
          <span class="isla-titulo">
            <span
              class="material-icons"
              style="font-size: 16px; vertical-align: middle"
            >
              place
            </span>
            {{ reporte?.valores?.fechaDevice | date: 'dd/MM/yyyy HH:mm:ss' }}
          </span>
        </mat-card-title>
      </mat-card-header>

      <!-- Contenido -->
      <mat-card-content class="isla-content">
        <div class="isla-info-section">
          <div class="isla-table-container">
            <table class="isla-table">
              <tbody>
                <!-- Grupo / Flota -->
                @if (reporte?.grupos?.length) {
                  @for (grupo of reporte.grupos; track grupo) {
                    <tr class="isla-row">
                      <td class="isla-label">Flota:</td>
                      <td class="isla-value">{{ grupo.nombre }}</td>
                    </tr>
                  }
                } @else {
                  <tr class="isla-row">
                    <td colspan="2" class="no-info">Sin flota asignada</td>
                  </tr>
                }

                <!-- Último Reporte -->
                @if (reporte?.fechaCreacion) {
                  <tr class="isla-row">
                    <td class="isla-label">Fecha de creación:</td>
                    <td class="isla-value">
                      {{ reporte?.fechaCreacion | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </td>
                  </tr>
                } @else {
                  <tr class="isla-row">
                    <td colspan="2" class="no-info">Sin reportar</td>
                  </tr>
                }

                <!-- Solo si es vehículo -->
                @if (reporte?.activo?.categoria === 'Vehículo') {
                  <!-- Marca y modelo -->
                  @if (reporte?.activo?.vehiculo?.marca) {
                    <tr class="isla-row">
                      <td class="isla-label">Marca y modelo:</td>
                      <td class="isla-value">
                        {{ reporte?.activo?.vehiculo?.marca }}
                        {{
                          reporte?.activo?.vehiculo?.modelo
                            ? ' - ' + reporte?.activo?.vehiculo?.modelo
                            : ''
                        }}
                      </td>
                    </tr>
                  }

                  <!-- Velocidad -->
                  @if (reporte?.valores?.velocidad) {
                    <tr class="isla-row">
                      <td class="isla-label">Velocidad:</td>
                      <td class="isla-value">
                        {{ reporte?.valores?.velocidad | number: '1.0-0' }} km/h
                      </td>
                    </tr>
                  } @else {
                    <tr class="isla-row">
                      <td colspan="2" class="no-info">
                        Velocidad no reportada
                      </td>
                    </tr>
                  }

                  <!-- Odómetro -->
                  @if (reporte?.valores?.odometro) {
                    <tr class="isla-row">
                      <td class="isla-label">Odómetro:</td>
                      <td class="isla-value">
                        {{
                          reporte?.valores?.odometro / 1000 | number: '1.0-0'
                        }}
                        km
                      </td>
                    </tr>
                  } @else {
                    <tr class="isla-row">
                      <td colspan="2" class="no-info">Odómetro no reportado</td>
                    </tr>
                  }

                  <!-- Chofer -->
                  @if (reporte?.usuario?._id) {
                    <tr class="isla-row">
                      <td class="isla-label">Chofer:</td>
                      <td class="isla-value">
                        <div
                          class="isla-foto-container"
                          [routerLink]="[
                            '../choferes/editar',
                            reporte?.usuario?._id,
                          ]"
                          style="cursor: pointer"
                        >
                          <div
                            class="isla-foto"
                            [style.background-image]="getFoto()"
                          ></div>
                          {{ reporte?.usuario?.datosPersonales?.nombre }}
                        </div>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>
